import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DfSelectModule } from '@design-factory/design-factory';
import { ComponentsModule } from '../components/components.module';
import { PointsOfSaleRoutingModule } from './points-of-sale-routing.module';
import { AgGridModule } from 'ag-grid-angular';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    PointsOfSaleRoutingModule,
    ComponentsModule,
    DfSelectModule,
    AgGridModule
  ]
})
export class PointsOfSaleModule {}
